// Kickstarter campaign — ONE shared setting for the whole site.
//
// - `url`: every campaign button points here.
// - `live`: flip to true ONLY after Jordy confirms the campaign is accepting
//   pledges. This switches every campaign status line, button label and helper
//   note below from pre-launch to live wording in one move. Never flip it
//   automatically based on the date.
// - `videoUrl`: Kickstarter video — paste a YouTube link or a /brand/*.mp4
//   path once the video is ready. While empty, the campaign page shows the
//   blank 16:9 placeholder; once set, the player takes its place with
//   controls, fullscreen and no autoplay.
export const CAMPAIGN = {
  url: "https://www.kickstarter.com/projects/jordytrachtenberg/tattooed-abroad",
  live: false,
  videoUrl: "",
  videoPoster: "",
  preLaunch: {
    status: "Launching November 10, 2026 on Kickstarter",
    cta: "Get notified on Kickstarter",
    note: "Follow the project on Kickstarter to get notified when we launch.",
  },
  liveMode: {
    status: "Now live on Kickstarter",
    cta: "Back Tattooed Abroad",
    note: "Explore the rewards and help us create Season One.",
  },
};

export const campaignCopy = CAMPAIGN.live ? CAMPAIGN.liveMode : CAMPAIGN.preLaunch;
